module.exports = __webpack_public_path__ + "static/img/chiilih.8b61572.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chiilih.svg
// module id = wSFD
// module chunks = 0